import { Modal } from 'react-bootstrap';
import { ArrowRightShort, Stars } from 'react-bootstrap-icons';
import { Spinner } from 'react-bootstrap';
import AutoGrowTextArea from '../common/AutoGrowTextArea';
import { useState } from 'react';
import { reportService } from '../../services/reportServices';
import { toast } from 'react-toastify';

export default function PromptRegenerationModal({
  isModalOpen,
  setIsModalOpen,
  selectedVariable,
  setSelectedVariable,
  isRTL,
  readOnly,
  handleReplacePlaceholder,
  id,
  translate
}) {
  const [isRegenerateProgress, setIsRegenerateProgress] = useState(false);

  const updatePlaceholder = async () => {
    setIsRegenerateProgress(true);
    const requestObj = {
      newPlaceholder: selectedVariable.newPlaceholder,
      aiResponseId: selectedVariable._id
    };

    const { response, error } = await reportService.updateReportPlaceholder(id, requestObj);
    if (error) {
      toast.error(error);
      setIsRegenerateProgress(false);
    } else {
      setSelectedVariable({ ...selectedVariable, newAiResponse: response.newAiResponse });
      setIsRegenerateProgress(false);
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setSelectedVariable(null);
  };

  return (
    <Modal
      size="lg"
      rtl={isRTL ? 'rtl' : 'ltr'}
      centered
      show={isModalOpen}
      onHide={handleModalClose}
      dialogClassName="modal-custom"
    >
      <Modal.Header closeButton style={{ flexDirection: isRTL ? 'row-reverse' : 'row', padding: 16 }}>
        <Modal.Title className="fs-5">{translate('edit_variable')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-0 mt-3" style={{ paddingLeft: '16px', paddingRight: '16px' }}>
        <label className="form-label fs-6">{translate('current_value')}</label>
        <div
          style={{
            color: 'gray',
            fontSize: 12,
            padding: 10,
            border: '1px solid #e0e0e0'
          }}
          className={`small bg-light rounded mb-2 text-muted-foreground`}
        >
          {selectedVariable?.value}
        </div>
        <div className="mb-2 mt-3">
          <label className="form-label fs-6">{translate('prompt')}</label>
          <div className="d-flex justify-content-between gap-2">
            <div style={{ flex: 1 }}>
              <AutoGrowTextArea
                as="textarea"
                type="text"
                value={selectedVariable?.newPlaceholder}
                placeholder={selectedVariable?.placeholder}
                onChange={e => setSelectedVariable({ ...selectedVariable, newPlaceholder: e.target.value })}
                rows={1}
                resize="none"
                style={{ fontSize: 14, padding: '8px 12px', minHeight: '40px' }}
              />
              <label style={{ fontSize: 12, color: '#71717A' }} className="form-label mt-1">
                {translate('update_prompt_to_generate_new_value')}
              </label>
            </div>

            <button
              disabled={readOnly || isRegenerateProgress}
              type="button"
              className="btn btn-dark m-0 align-self-start"
              onClick={updatePlaceholder}
              style={{ minHeight: '40px' }}
            >
              {isRegenerateProgress ? (
                <Spinner animation="border" className="gold-spinner me-1 ms-1" size="sm" />
              ) : (
                <Stars className="custom-shining-gold me-1 ms-1" />
              )}
              {translate('regenerate')}
            </button>
          </div>
        </div>
        {selectedVariable?.newAiResponse && (
          <div className="mt-2">
            <label className="form-label fs-6">{translate('regenerated_value')}</label>
            <AutoGrowTextArea
              as="textarea"
              type="text"
              value={selectedVariable?.newAiResponse?.value ?? ''}
              placeholder={selectedVariable?.newAiResponse?.placeholder}
              onChange={e =>
                setSelectedVariable({
                  ...selectedVariable,
                  newAiResponse: {
                    ...selectedVariable.newAiResponse,
                    value: e.target.value
                  }
                })
              }
              rows={1}
              resize="none"
              style={{ fontSize: 14, padding: '8px 12px', minHeight: '40px' }}
            />
          </div>
        )}
      </Modal.Body>
      <Modal.Footer style={{ paddingLeft: '16px', paddingRight: '16px' }}>
        <div className="d-flex justify-content-end gap-2 m-0">
          <button
            style={{ minHeight: '40px', fontSize: 14 }}
            type="button"
            className="btn btn-light m-0"
            onClick={handleModalClose}
          >
            {translate('cancel')}
          </button>
          {selectedVariable?.newAiResponse && (
            <button
              style={{ minHeight: '40px', fontSize: 14 }}
              disabled={readOnly}
              type="button"
              className="btn btn-dark text-white m-0 d-flex align-items-center"
              onClick={handleReplacePlaceholder}
            >
              <ArrowRightShort size={20} className="me-1" />
              {translate('insert')}
            </button>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  );
}
